// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2v6H8","choiceBoxes":"toolbarselects_choiceBoxes__2KL2y","simpleField":"toolbarselects_simpleField__2Dj-G"};